import { ButtonLink } from '@getslot/ui-web/button'
import { ChipLink } from '@getslot/ui-web/chip'
import { createLink } from '@tanstack/react-router'
import { AdminNavItem } from './side-nav'

export const RouterChipLink = createLink(ChipLink)
export const RouterSideNavItem = createLink(AdminNavItem)
export const RouterButtonLink = createLink(ButtonLink)
